// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"C8-z"};